import { IoIosWarning } from "react-icons/io";

export const NoData = () => (
  <div className="p-4 text-center">
    <IoIosWarning className="mx-auto text-primaryPurple-100" size={40} />
    <span>No Data Available</span>
  </div>
);
